var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeUpActivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9221 2.03294C13.6137 1.87508 14.6208 2.29666 15.2574 3.04057C15.9628 3.86433 16.2745 4.89477 16.1591 6.16823C16.1099 6.71616 15.9652 7.33013 15.7285 8.01304C16.5372 7.88863 17.3579 7.86991 18.1709 7.95711C20.0719 8.16207 21.1402 9.46864 20.9852 11.1203C20.917 11.8323 20.6724 12.4386 20.2566 12.9136C20.6059 13.6244 20.7453 14.3274 20.6582 15.0132C20.5577 15.803 20.1404 16.4607 19.4471 16.9716C19.3931 17.6646 19.2423 18.2178 18.9751 18.6318C18.7647 18.9662 18.4901 19.251 18.1692 19.4663C18.0668 20.15 17.8517 20.6849 17.5003 21.0608C16.9177 21.6867 15.8762 22.06 14.9251 21.9921C14.0228 21.9281 13.4882 21.8118 12.2287 21.3919C11.443 21.13 9.86167 20.7045 7.50018 20.1179V9.63502C7.90509 9.43484 8.29786 9.20696 8.67439 8.95053C9.66708 8.2726 10.3979 7.29983 10.6774 6.42391C10.7731 6.12198 10.8251 5.87187 10.9217 5.28399C11.0524 4.4953 11.1342 4.12848 11.3216 3.65669C11.71 2.67481 12.2193 2.19398 12.9221 2.03294ZM5.70019 20.0141H4.13575C3.87496 20.0041 3.63938 19.9302 3.4379 19.7815C3.14437 19.5645 3.00571 19.2228 3.00284 18.8289L3.00548 11.5065C2.97328 11.1166 3.0828 10.7586 3.34034 10.4926C3.58189 10.2426 3.89724 10.1242 4.23067 10.1322H5.70019V20.0141Z",
    fill: "url(#paint0_linear_237_8576)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_8576",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#825AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D73E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeUpActivated);
export default __webpack_public_path__ + "static/media/like_up_activated.8ea63c535a51367547349fba46e43cca.svg";
export { ForwardRef as ReactComponent };